/* template */
<template><page><base-container><div :class='["btn-item"]'><cube-basic-picker/></div><div :class='["btn-item"]'><cube-time-picker/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_2030b3da"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_2030b3da"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_2030b3da"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_2030b3da"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker4ed831f3%2Findex")),'cube-time-picker':getComponent(require("./time-picker.mpx?isComponent&outputPath=components%2Ftime-picker3e57f054%2Findex")),'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>